import React from 'react';
import { Link } from 'react-router-dom';
import testRecords from './testRecordsData';

const MemberTestRecords = ({ slug }) => {
  const records = testRecords[slug];
  if (!records || records.length === 0) return null;

  return (
    <div className="test-records" style={{ marginTop: 20 }}>
      <h3 style={{ marginBottom: 10 }}>TEST RECORDS</h3>
      <table style={{ margin: '0 auto', borderCollapse: 'collapse', fontSize: 14 }}>
        <thead>
          <tr>
            <th style={{ padding: '4px 8px', borderBottom: '1px solid #ccc' }}>Date</th>
            <th style={{ padding: '4px 8px', borderBottom: '1px solid #ccc' }}>Rank</th>
            <th style={{ padding: '4px 8px', borderBottom: '1px solid #ccc' }}>Result</th>
          </tr>
        </thead>
        <tbody>
          {records.map((r) => (
            <tr key={r.date}>
              <td style={{ padding: '4px 8px' }}>
                {r.page ? <Link to={r.page}>{r.date}</Link> : r.date}
                {r.venue && <div style={{ fontSize: 12, color: '#666' }}>{r.venue}</div>}
              </td>
              <td style={{ padding: '4px 8px' }}>{r.rank}</td>
              <td style={{ padding: '4px 8px' }}>{r.result}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MemberTestRecords;
